import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  name: 'select-edit'
})
export default class SelectEdit extends Vue {
}
